import { useEffect, useLayoutEffect, useState, useContext } from "react";
import { Input } from "design-react-kit";
import UploadFile from "../../Components/UploadFile";
import { Link, useLocation, useHistory } from "react-router-dom";
import moment from "moment";
import { useCookies } from "react-cookie";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import { TokenContext } from "../../Components/TokenContext";
import Loader from "../../Components/Loader";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const number = new RegExp("^[+]?([0-9]{0,})*[,]?([0-9]{0,2})?$", "g");

function UploadISEE(props) {
  const apiToken = useContext(TokenContext);
  const [value, setValue] = useState();
  const [uploadISEE, setUploadISEE] = useState(false);
  const [validation, setValidation] = useState(false);
  const [validationISEE, setValidationISEE] = useState(false);
  const [skipValidationISEE, setSkipValidationISEE] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [data, setData] = useState();
  const [userId, setUserId] = useState();
  const [errorMessage, setErrorMessage] = useState(false);
  const [year, setYear] = useState(false);
  const [date, setDate] = useState(false);

  let query = useQuery();

  useEffect(() => {
    if (query.get("userId")) {
      setUserId(query.get("userId"));
      const d = moment();
      setYear(d.year());
      var localFormat = "YYYY-MM-DD[T]HH:mm:ss";
      setDate(d.format(localFormat));
    }
  }, []);

  const sendISEE = async () => {
    setValidation(true);
    setValidationISEE(true);

    let passedValidation = true;

    let tempData = {};

    if (!skipValidationISEE) {
      if (uploadISEE) {
        var splitBase64 = uploadISEE.split(",");

        const mimeType = splitBase64[0]; // Il tipo MIME completo
        const parts = mimeType.split(";"); // Suddivide la stringa in base al carattere ';'
        const imageType = parts[0].split(":")[1]; // Rimuovi "data:" dalla parte centrale

        tempData["base64"] = splitBase64[1];
        tempData["type"] = imageType;
      } else {
        passedValidation = false;
        setValidationISEE(false);
      }
    }

    tempData["year"] = year;
    tempData["date"] = date;

    if (value == "" || value == " " || !value) passedValidation = false;

    tempData["userId"] = userId;
    tempData["value"] = value === "" ? "0.00" : value;

    tempData["value"] = (tempData["value"] ?? "")
      .replace(".", "")
      .replace(",", ".");

    if (passedValidation) {
      var dataJson = JSON.stringify(tempData);
      setData(dataJson);
      if (apiToken) {
        toggleModal(!isOpen);
      }
    }
  };

  const sendISEEApi = async () => {
    Repo.postSendIseeOperator(apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          window.location.href =
            props.subfolder + "/lista_utenti/cartella_sociale?id=" + userId;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const skipIsee = (event) => {
    if (skipValidationISEE === true) setSkipValidationISEE(false);
    else setSkipValidationISEE(true);
  };

  return (
    <div>
      <h1>Carica ISEE</h1>
      <div className="row">
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Inserisci un nuovo Isee associato all'utente</p>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8">
          <div className="card-wrapper card-space">
            <div className="card card-bg card-big roundedCustom">
              <div className="card-body">
                <UploadFile
                  setErrorMessage={setErrorMessage}
                  typeFile={[
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "application/pdf",
                  ]}
                  handleFile={setUploadISEE}
                ></UploadFile>
                {errorMessage && (
                  <div className="text-danger">
                    Carica un file con un formato supportato
                  </div>
                )}
                {validation && !validationISEE ? (
                  <div className="text-danger">
                    Non è stato caricato nessun documento
                  </div>
                ) : (
                  <></>
                )}
                {uploadISEE && (
                  <object
                    className="mt-5"
                    width="100%"
                    height="900"
                    data={uploadISEE}
                    type="application/pdf"
                  ></object>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 pl-5">
          <div className="card-wrapper card-space">
            <div className="card card-bg card-big roundedCustom">
              <div className="card-body">
                <h6>Valore ISEE*</h6>

                <div className="row mb-4">
                  <Input
                    id="value"
                    value={value?.toString()}
                    name="Valore ISEE"
                    onChange={(e) =>
                      setValue(
                        e.target.value.match(number) ? e.target.value : value,
                      )
                    }
                    {...(validation &&
                      (value == "" || value == " " || !value) && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div",
                      })}
                  />
                </div>

                <div className="row mb-4">
                  <Input
                    id="year"
                    value={year?.toString()}
                    name="Anno"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      setYear(
                        inputValue.match(number) || inputValue === ""
                          ? inputValue
                          : year,
                      );
                    }}
                    {...(validation &&
                      (!year || year.toString().trim() === "") && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div",
                      })}
                  />
                </div>

                <div className="form-check">
                  <Input
                    id="checkbox1"
                    type="checkbox"
                    checked={skipValidationISEE}
                    onChange={() => skipIsee(this)}
                  />
                  <label htmlFor="checkbox1">Escludi caricamento File</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-2">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-primary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => sendISEE()}
            title="Conferma"
          >
            Conferma
          </button>
        </div>
      </div>
      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Caricamento ISEE"
        body="Confermi di voler caricare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendISEEApi()}
      ></ModalComponent>
    </div>
  );
}

export default UploadISEE;
